var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRiskTip = function SvgRiskTip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "riskTip_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v900H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "riskTip_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "riskTip_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.52 8.743a.34.34 0 0 1 .34.339v.865a.34.34 0 0 1-.34.339H.657a.34.34 0 0 1-.34-.34v-.864a.34.34 0 0 1 .34-.34h.865ZM1.864 0a.34.34 0 0 1 .313.363l-.534 7.208a.34.34 0 0 1-.338.314H.87a.34.34 0 0 1-.338-.314L.001.364 0 .339A.34.34 0 0 1 .34 0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#riskTip_svg__a)",
    transform: "translate(-432 -290)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#riskTip_svg__b)",
    transform: "translate(432 290)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ED210C",
    d: "M0 0h24v24H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#riskTip_svg__c)",
    transform: "translate(442.5 297.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h2.177v10.286H0V0z"
  })))));
};
export default SvgRiskTip;